import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const ChipWrapper = styled(Box)(
  ({ theme }) => `
  align-items: center;
  display: flex;
 `
);
